export default __webpack_public_path__ + "static/media/JosetteLovelace.94aa8ea6.png";